// Designed by Experts Section Data
export const DESIGNED_BY_EXPERTS_DATA = {
  heading: 'Designed by experts',
  description: `With our solutions, you don't have to worry about complying with the latest regulations.
    60+ in-house tax experts, co-build and test every product feature.
     Over 60,000 tax experts give us constant
     feedback which helps us stay on top of every new tax clause.`,
};
